<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      ref="tablaCesionesPlazas"
      :titulo="$t ('Cesiones de plazas')"
      icono="mdi-sync"
      tabla="cespla"
      :campos="['id_ins-', 'fechoralt-', 'id_empinq', 'id_pas+', 'id_zon-', 'fechorini', 'fechorfin', 'obs-', 'numpla', 'lismat']"
      :campos-filtrables="['id_ins', 'fechorini', 'id_empinq', 'id_pas', 'id_zon']"
      :parametros="parametros"
      :objeto-definicion-campos="dc"
      :objeto-registro-formulario="rf"
      busqueda-rapida
      titulo-crud="cesión de plaza"
      :permitir-anadir="permisoEscritura"
      :permitir-modificar="permisoEscritura"
      :permitir-eliminar="permisoEscritura"
      :evento-antes-abrir-formulario-datos="antesAbrirFormulario"
      :item-class="obtenerItemClassTablaDatos"
    >
      <template v-slot:debajo-titulo>
        <v-tabs fixed-tabs background-color="#D7CCD7" v-model="tabSeleccionado" mobile-breakpoint="0" style="width: 100%" @change="actualizarTabla">
          <v-tab v-for="tab in arrayTabs" :key="tab.titulo"><v-icon class="mr-2">{{tab.icono}}</v-icon>{{ $t (tab.titulo) }}</v-tab>
        </v-tabs>
      </template>

      <template v-slot:[`item.id_cespla`]="{ item }">
        <span class="localizador">{{ item.loc }}</span>
        <div v-if="item.id_estres != 0" class="estado-reserva">{{ item.id_estres__VT }}</div>
      </template>

      <template v-slot:[`item.lismat`]="{ item }">
        <template v-if="item.lismat">
          <span class="d-flex flex-wrap">
            <span v-for="(matricula, idx) in item.lismat.split (',')" :key="idx" class="matricula">{{ matricula }}</span>
          </span>
        </template>
      </template>

      <template v-slot:default="{ definicionCampos, datosRegistro, accionCrud, esAccionEliminar }">
        <CampoFormularioDatos v-if="accionCrud != 'C'" nombre-campo="fechoralt" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" disabled />
        <CampoFormularioDatos v-if="definicionCampos['id_empinq'].visibilidad==''" nombre-campo="id_empinq" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="accionCrud != 'C'" @change="changeSelectEmpresaInquilina" />
        <CampoFormularioDatos ref="id_pas" nombre-campo="id_pas" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="accionCrud != 'C'" />
        <CampoFormularioDatos :min="fechaActual" :max="fechaMaximaInicioCesion" nombre-campo="fechorini" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" :ajustar-segundos="0" :ajustar-milisegundos="0" hora-por-defecto="00:00" />
        <CampoFormularioDatos :min="fechaMinimaFinCesion" :max="fechaDentroTresMeses" nombre-campo="fechorfin" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" :ajustar-segundos="59" :ajustar-milisegundos="998" hora-por-defecto="23:59" />
        <CampoFormularioDatos nombre-campo="obs" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
      </template>

    </TablaDatosAPI>

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";
import CampoFormularioDatos from "@/components/CampoFormularioDatos.vue";
import { DateTime } from "luxon";
import api from '@/api'

export default {
  components: { TablaDatosAPI,
                CampoFormularioDatos },
  data: () => ({
    arrayTabs: [
      { titulo: "Caducadas", icono: "mdi-calendar-arrow-left", parametro: "filtroCaducadas" },
      { titulo: "Actuales", icono: "mdi-calendar-today", parametro: "filtroActuales" },
      { titulo: "Próximas", icono: "mdi-calendar-arrow-right", parametro: "filtroProximas" },
      { titulo: "(Todas)", icono: "mdi-calendar-blank-multiple", parametro: "" },
    ],
    tabSeleccionado: 1,
    dc: {},
    rf: {}
  }),
  methods: {
    actualizarTabla(){
      this.$nextTick (() => {
        this.$refs.tablaCesionesPlazas.actualizarDatosPorCambiosEnBusqueda();
      });
    },
    changeSelectEmpresaInquilina () {
      this.dc ['id_pas'].dominio_valores = {};

      if (this.rf ['id_empinq']) {
        // debemos actualizar el select de "pases" cada vez que cambiemos el select de "empresa inquilina"
        api.obtenerGestionCesionesPlazasPases ({ id_empinq: this.rf ['id_empinq'] })
          .then ( (respuesta) => {
            respuesta.data.filas.forEach (fila => {
              this.dc ['id_pas'].dominio_valores [fila.id_pas] = fila.tit + (fila.numpla ? ' - Plaza ' + fila.numpla : '');
            });
          })
          .finally(() => {
            this.$refs['id_pas'].actualizarItemsSelect();

            this.$nextTick (() => { // usamos "$nextTick" para ejecutar lo siguiente después de que se hayan actualizado los items del select
              let ids_pases = Object.keys (this.dc ['id_pas'].dominio_valores);
              if (ids_pases.length == 1)
                this.$set (this.rf, 'id_pas', JSON.parse (ids_pases [0]));
            });
          });
      } else if (this.$refs['id_pas']) {
        this.$refs['id_pas'].actualizarItemsSelect();
      }
    },
    antesAbrirFormulario () {
      this.changeSelectEmpresaInquilina ();
    },
    obtenerItemClassTablaDatos (item) {
      if (DateTime.fromFormat (item.fechorini, "yyyy-MM-dd HH:mm:ss").diffNow() > 0)
        return "reserva_proxima";
      else if (DateTime.fromFormat (item.fechorfin, "yyyy-MM-dd HH:mm:ss").diffNow() < 0)
        return "reserva_caducada";
    }
  },
  computed: {
    permisoEscritura() {
      return this.$store.operador.atributosRol.includes ("gesres");
    },
    parametros() {
      let aux = {};
      if (this.arrayTabs [this.tabSeleccionado].parametro)
        aux [this.arrayTabs [this.tabSeleccionado].parametro] = { valor: 1, descripcion: this.arrayTabs [this.tabSeleccionado].titulo };
      return aux;
    },
    fechaActual() {
      return DateTime.local().toISODate();
    },
    fechaDentroTresMeses() {
      return DateTime.local().plus({ months: 3 }).toISODate();
    },
    fechaMaximaInicioCesion() {
      if (this.rf ['fechorfin'])
        return DateTime.fromFormat (this.rf ['fechorfin'], "yyyy-MM-dd HH:mm:ss").toISODate();
      else
        return this.fechaDentroTresMeses;
    },
    fechaMinimaFinCesion() {
      if (this.rf ['fechorini'])
        return DateTime.fromFormat (this.rf ['fechorini'], "yyyy-MM-dd HH:mm:ss").toISODate();
      else
        return DateTime.local().toISODate();
    }
  },
  created() {
    this.tabSeleccionado = this.$store.leer_preferencia ('tabSeleccionado', 1, 'gestion_cesiones');
  },
  watch: {
    tabSeleccionado() {
      this.$store.guardar_preferencia ('tabSeleccionado', this.tabSeleccionado, 1, 'gestion_cesiones');
    }
  }
};
</script>

<style>
  .cesion_caducada {
    color: #7E57C2;
  }
  .cesion_proxima {
    color: #689F38;
  }
</style>